export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4684.d8467415.jpg";